export function buildVotesExportByEvalModelIdQueryV1(workspaceId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.VotesExportByEvalModelIdQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'EvalModelId': evalModelId
	}
}

export function buildCriteriaPanelistsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.CriteriaPanelistsPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}


export function buildCriteriaSurveyPanelistsQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.CriteriaSurveyPanelistsQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId
	}
}

export function buildCriteriaPanelistsManagerQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.CriteriaPanelistsManagerQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId
	}
}

export function buildCriteriaPanelistQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.CriteriaPanelistQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId
	}
}

export function buildCriteriaAccessLinksBySurveyIdQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.CriteriaAccessLinksBySurveyIdQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
	}
}


export function buildExportAccessLinksBySurveyIdQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.ExportAccessLinksBySurveyIdQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
	}
}


export function buildCriteriaSurveyQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.CriteriaSurveyQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}

export function buildSubSurveysManagerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.SubSurveysManagerQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'MasterSurveyId': surveyId,
	}
}

export function buildMeetingManagerPageQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.MeetingManagerPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}

export function buildMeetingQuestionReviewQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, questionId: string)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.MeetingQuestionReviewQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
		'QuestionId': questionId
	}
}


export function buildPanelistSurveyDashboardPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.PanelistSurveyDashboardPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId
	}
}

export function buildPanelistMeetingPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.PanelistMeetingPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId
	}
}

export function buildPanelistSurveyCriterionPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number, criterionId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.PanelistSurveyCriterionPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId,
		'CriterionId': criterionId
	}
}

export function buildPanelistSurveyCriterionConsistencyAnalysisQueryV1(workspaceId: number, criteriaHierarchyId: number, evalModelId: number, surveyId: number, projectUserId: number, criterionId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.PanelistSurveyCriterionConsistencyAnalysisQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'CriteriaHierarchyId': criteriaHierarchyId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId,
		'CriterionId': criterionId
	}
}


export function buildProjectUserVoteQueryV1(workspaceId: number, projectUserId: number, questionId: string)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.ProjectUserVoteQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectUserId': projectUserId,
		'QuestionId': questionId
	}
}


export function buildPanelDisagreementsQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.PanelDisagreementsQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}

export function buildPanelConsistencyAnalysisQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.PanelConsistencyAnalysisQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}

export function buildPanelistConsistencyAnalysisQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.CriteriaSurveys.Queries.PanelistConsistencyAnalysisQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId,
	}
}




